import { useState, useEffect } from 'react';

import countryList from '../../services/currencies.json';
import { swapCountryAndLanguage } from 'src/common/utils/swapCountryAndLanguage';
import { IBMLocale } from 'src/common/locale/mapValidLocale';

import { LangDefaults, useLang } from 'src/common/hooks/widgets/useLang';
import UseCase1 from '../UseCase1/UseCase1';
import MenuPage from '../MenuPage/MenuPage';

export interface MainPageProps {
  langCode: string;
  test: boolean;
  countryToTest: string;
  bpName: string;
}

const MainPage = ({ langCode, test, countryToTest, bpName }: MainPageProps) => {
  const localeCode = swapCountryAndLanguage(langCode as IBMLocale);
  const [, setCurrency] = useState('');
  const [, setCountry] = useState('');
  // lang and userlocale is based out of ddo
  const [lang, userLocale] = useLang(
    countryList,
    test,
    countryToTest,
    setCurrency,
    setCountry,
    localeCode,
  );
  /* Have urx form deault in us-en when on language us page */
  const [localCurrency, setlocalCurrency] = useState<string>(localeCode);
  useEffect(() => {
    setlocalCurrency(userLocale); // show local Currency
  }, [userLocale, localeCode, localCurrency]);

  let localStorageFound = localStorage.getItem('langLocale');
  if (localStorageFound == null)
    localStorageFound = LangDefaults.localCountryLang;
  const [showOption, setShowOption] = useState(0);

  return (
    <div>
      {showOption === 0 ? (
        <MenuPage
          langCode={localeCode}
          test={test}
          countryToTest={countryToTest}
          bpName={bpName}
          setShowOption={setShowOption}
        />
      ) : (
        <UseCase1 bpName={bpName} setShowOption={setShowOption} lang={lang} />
      )}
    </div>
  );
};

export default MainPage;
